import * as React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

import AuthService from '../../../services/Auth'

import * as style from './style.module.css'
import { Redirect } from 'react-router';

export interface LogoutProps {}

export class LogoutComponent extends React.Component<LogoutProps, any> {

  OAuth2Uri: string

  componentDidMount() {
    new AuthService().logout()
  }

  render() {
    return <Redirect to="/login" />
  }
}
